
    import Vue from "vue";

    const END_POINT = "/account-terminology";

    const getAccountTerminology = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllAccountTerminologies = data => Vue.axios.get(END_POINT, {params: data});

    const createAccountTerminology = accountTerminology => Vue.axios.post(END_POINT,  accountTerminology );

    const createAllAccountTerminologies = AccountTerminologies => Vue.axios.post(END_POINT + "/all",  AccountTerminologies );

    const updateAccountTerminology = accountTerminology => Vue.axios.put(END_POINT  + "/" + accountTerminology.id,  accountTerminology );

    const deleteAccountTerminology = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getAccountTerminology,
      getAllAccountTerminologies,
      createAccountTerminology,
      createAllAccountTerminologies,
      updateAccountTerminology,
      deleteAccountTerminology
    };
    